/**
 * Widget 错误处理工具
 */

/**
 * Widget 错误类
 */
export class WidgetError extends Error {
  constructor(
    public code: string,
    message: string,
    public details?: any
  ) {
    super(message);
    this.name = 'WidgetError';
  }
}

/**
 * 错误码定义
 */
export const ErrorCodes = {
  NETWORK_ERROR: 'NETWORK_ERROR',
  SERVER_ERROR: 'SERVER_ERROR',
  RATE_LIMIT: 'RATE_LIMIT',
  UNAUTHORIZED: 'UNAUTHORIZED',
  INVALID_CONFIG: 'INVALID_CONFIG',
  BROWSER_NOT_SUPPORTED: 'BROWSER_NOT_SUPPORTED',
  INITIALIZATION_FAILED: 'INITIALIZATION_FAILED',
} as const;

/**
 * 错误消息映射（用户友好）
 */
export const ErrorMessages: Record<string, string> = {
  [ErrorCodes.NETWORK_ERROR]: '网络连接失败，请检查网络后重试',
  [ErrorCodes.SERVER_ERROR]: '服务器错误，请稍后再试',
  [ErrorCodes.RATE_LIMIT]: '请求过于频繁，请稍后再试',
  [ErrorCodes.UNAUTHORIZED]: '未授权访问',
  [ErrorCodes.INVALID_CONFIG]: '配置无效',
  [ErrorCodes.BROWSER_NOT_SUPPORTED]: '浏览器版本过低，请升级后使用',
  [ErrorCodes.INITIALIZATION_FAILED]: 'Widget 初始化失败',
};

/**
 * 获取用户友好的错误消息
 */
export function getErrorMessage(error: Error | WidgetError): string {
  if (error instanceof WidgetError) {
    return ErrorMessages[error.code] || error.message;
  }
  return error.message || '发生未知错误';
}

/**
 * 日志工具
 */
export class Logger {
  private debug: boolean;

  constructor(debug: boolean = false) {
    this.debug = debug;
  }

  info(message: string, ...args: any[]): void {
    if (this.debug) {
      console.log(`[SmartCS:INFO] ${message}`, ...args);
    }
  }

  warn(message: string, ...args: any[]): void {
    if (this.debug) {
      console.warn(`[SmartCS:WARN] ${message}`, ...args);
    }
  }

  error(message: string, error?: Error, ...args: any[]): void {
    console.error(`[SmartCS:ERROR] ${message}`, error, ...args);
  }

  debugLog(message: string, ...args: any[]): void {
    if (this.debug) {
      console.log(`[SmartCS:DEBUG] ${message}`, ...args);
    }
  }
}

/**
 * 全局日志实例
 */
let loggerInstance: Logger | null = null;

export function getLogger(debug?: boolean): Logger {
  if (!loggerInstance) {
    loggerInstance = new Logger(debug);
  }
  return loggerInstance;
}
